"use client";

export default function BottomCta() {
  return (
    <section className="bg-secondary py-20 px-4 md:px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-[36px] font-bold text-white mb-4">
          Schedule Your Window Tune-Up
        </h2>
        <p className="text-cream max-w-[720px] mx-auto mb-8 text-base">
          Annual maintenance plans available. Call for a free phone quote.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange hover:bg-orange/90 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            Call (786) 377-4452
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-secondary transition-colors whitespace-nowrap"
          >
            Email Windows and Doors Repair Miami
          </a>
        </div>
      </div>
    </section>
  );
}